import React, { useEffect, useState } from 'react';
import { Table, Button, FormInput, ColumnProps, Form, Row, Col, FormResetButton } from '@digital/ui';
import { Icon, Tooltip } from 'antd';
import { compareText, compareNumber } from '@app/helpers/comparators';
import {
  CicloOrcamentarioRelatorio,
  CicloOrcamentarioRelatorioResult,
  Filtros,
} from '@app/api/relatorioCicloorcamentario';
import { PaginationConfig } from 'antd/lib/pagination';
import { formatCurrencyBr } from '@app/helpers/numbers';

interface RelatorioCicloOrcamentarioTabelaProps {
  cicloOrcamentarioRelatorioTotal: CicloOrcamentarioRelatorio;
  filtro: Filtros;
  mostrarColunaDetalhe: boolean;
  quantidadeItemPaginacao: number;
  mostrarColunaDetalheFechamento?: boolean;
  fechamentoId?: string;
}

const RelatorioCicloOrcamentarioTabela = (props: RelatorioCicloOrcamentarioTabelaProps) => {
  const {
    cicloOrcamentarioRelatorioTotal,
    filtro,
    mostrarColunaDetalhe,
    quantidadeItemPaginacao,
    mostrarColunaDetalheFechamento,
    fechamentoId,
  } = props;
  const [cicloOrcamentarioRelatorioResult, setCicloOrcamentarioRelatorioResult] = useState(
    cicloOrcamentarioRelatorioTotal,
  );

  const [valorTotalA, setValorTotalA] = useState(cicloOrcamentarioRelatorioTotal.valorTotalA);
  const [valorTotalB, setValorTotalB] = useState(cicloOrcamentarioRelatorioTotal.valorTotalB);
  const [valorTotalC, setValorTotalC] = useState(cicloOrcamentarioRelatorioTotal.valorTotalC);
  const [valorTotalD, setValorTotalD] = useState(cicloOrcamentarioRelatorioTotal.valorTotalD);
  const [valorTotalE, setValorTotalE] = useState(cicloOrcamentarioRelatorioTotal.valorTotalE);
  const [valorTotalF, setValorTotalF] = useState(cicloOrcamentarioRelatorioTotal.valorTotalF);
  const [valorTotalG, setValorTotalG] = useState(cicloOrcamentarioRelatorioTotal.valorTotalG);
  const [valorTotalH, setValorTotalH] = useState(cicloOrcamentarioRelatorioTotal.valorTotalH);

  const idVrp = '00000000-0000-0000-0000-000000000000';

  const calcularTotal = () => {
    setValorTotalA(cicloOrcamentarioRelatorioTotal.valorTotalA);
    setValorTotalB(cicloOrcamentarioRelatorioTotal.valorTotalB);
    setValorTotalC(cicloOrcamentarioRelatorioTotal.valorTotalC);
    setValorTotalD(cicloOrcamentarioRelatorioTotal.valorTotalD);
    setValorTotalE(cicloOrcamentarioRelatorioTotal.valorTotalE);
    setValorTotalF(cicloOrcamentarioRelatorioTotal.valorTotalF);
    setValorTotalG(cicloOrcamentarioRelatorioTotal.valorTotalG);
    setValorTotalH(cicloOrcamentarioRelatorioTotal.valorTotalH);
  };

  useEffect(() => {
    if (
      cicloOrcamentarioRelatorioTotal &&
      cicloOrcamentarioRelatorioTotal.result &&
      cicloOrcamentarioRelatorioTotal.result.length > 0
    ) {
      cicloOrcamentarioRelatorioTotal.result.map(item => {
        if (item.area === null) item.area = '';
        if (item.areaNome === null) item.areaNome = '';
        if (item.diretoria === null) item.diretoria = '';
        if (item.diretoriaNome === null) item.diretoriaNome = '';
        if (item.departamento === null) item.departamento = '';
        if (item.departamentoNome === null) item.departamentoNome = '';
      });
    }

    setCicloOrcamentarioRelatorioResult(cicloOrcamentarioRelatorioTotal);
    calcularTotal();
  }, [cicloOrcamentarioRelatorioTotal]);

  useEffect(() => {
    if (cicloOrcamentarioRelatorioTotal && cicloOrcamentarioRelatorioTotal.result) {
      calcularTotalColunasAoIniciar();
    }
  }, []);

  const calcularTotalColunasAoIniciar = () => {
    let totalA = 0;
    let totalB = 0;
    let totalC = 0;
    let totalD = 0;
    let totalE = 0;
    let totalF = 0;
    let totalG = 0;
    let totalH = 0;

    cicloOrcamentarioRelatorioTotal.result.map(item => {
      totalA += item.capExDecimal;
      totalB += item.contratadoDecimal;
      totalC += item.executadoDecimal;
      totalD += item.requisitadoDecimal;
      totalE += item.compromissadoDecimal;
      totalF += item.aContratarDecimal;
      totalG += item.forecastDecimal;
      totalH += item.saldoCapExDecimal;
    });

    setValorTotalA(formatCurrencyBr(totalA));
    setValorTotalB(formatCurrencyBr(totalB));
    setValorTotalC(formatCurrencyBr(totalC));
    setValorTotalD(formatCurrencyBr(totalD));
    setValorTotalE(formatCurrencyBr(totalE));
    setValorTotalF(formatCurrencyBr(totalF));
    setValorTotalG(formatCurrencyBr(totalG));
    setValorTotalH(formatCurrencyBr(totalH));
  };

  const colluns: ColumnProps<CicloOrcamentarioRelatorioResult>[] = [
    {
      title: 'N',
      dataIndex: 'numeroLinha',
      sorter: (a, b) => compareNumber(a.numeroLinha, b.numeroLinha),
    },
    {
      title: 'CÓD. PROJETO',
      dataIndex: 'codProjeto',
      sorter: (a, b) => compareText(a.codProjeto, b.codProjeto),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar CÓD. PROJETO"
              name="codProjeto"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') {
                    clearFilters(selectedKeys || []);
                  }
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) => {
        const resultFiltro =
          record.codProjeto !== undefined &&
          record.codProjeto
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        return resultFiltro;
      },
    },
    {
      title: 'NOME DO PROJETO',
      dataIndex: 'nomeprojeto',
      sorter: (a, b) => compareText(a.nomeprojeto, b.nomeprojeto),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar CÓD. PROJETO"
              name="nomeprojeto"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') {
                    clearFilters(selectedKeys || []);
                  }
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) => {
        const resultFiltro =
          record.nomeprojeto !== undefined &&
          record.nomeprojeto
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());

        return resultFiltro;
      },
    },
    {
      title: 'Dir',
      dataIndex: 'diretoria',
      render: (text, row, index) => {
        return (
          <>
            <Tooltip title={row.diretoriaNome}>
              <span>{row.diretoria}</span>
            </Tooltip>
          </>
        );
      },
      sorter: (a, b) => compareText(a.diretoria, b.diretoria),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar CÓD. PROJETO"
              name="diretoria"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.diretoria !== undefined &&
        record.diretoria
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Área',
      dataIndex: 'area',
      render: (text, row, index) => {
        return (
          <>
            <Tooltip title={row.areaNome}>
              <span>{row.area}</span>
            </Tooltip>
          </>
        );
      },
      sorter: (a, b) => compareText(a.area, b.area),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar"
              name="area"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) => {
        try {
          if (record != undefined
            && record.hasOwnProperty('area')
            && record.area != null) {
            return record.area.toLowerCase() == value.toLowerCase()
          }
        } catch (e) {
          // console.log(e);
        }
        return false;
      }

    },
    {
      title: 'Dep',
      dataIndex: 'departamento',
      render: (text, row, index) => {
        return (
          <>
            <Tooltip title={row.departamentoNome}>
              <span>{row.departamento}</span>
            </Tooltip>
          </>
        );
      },
      sorter: (a, b) => compareText(a.departamento, b.departamento),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar"
              name="departamento"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) => {
        try {
          if (record != undefined
            && record.hasOwnProperty('departamento')
            && record.departamento != null) {
            return record.departamento.toLowerCase() == value.toLowerCase()
          }
        } catch (e) {
          // console.log(e);
        }
        return false;
      }

    },
    {
      dataIndex: 'totalizadorColunaA',
      align: 'center',
      title: column => {
        return <div id={'ColunaTotalizadorColunaA'}> {valorTotalA}</div>;
      },
      children: [
        {
          title: 'A',
          children: [
            {
              title: 'Orçado Ano',
              dataIndex: 'capEx',
              align: 'center',
            },
          ],
        },
      ],
    },
    {
      dataIndex: 'totalizadorColunaB',
      align: 'center',
      title: `${valorTotalB}`,
      children: [
        {
          title: 'B',
          children: [
            {
              title: 'Contratado',
              dataIndex: 'contratado',
              align: 'center',
            },
          ],
        },
      ],
    },
    {
      dataIndex: 'totalizadorColunaC',
      align: 'center',
      title: `${valorTotalC}`,
      children: [
        {
          title: 'C',
          children: [
            {
              title: 'Executado',
              dataIndex: 'executado',
              align: 'center',
            },
          ],
        },
      ],
    },
    {
      dataIndex: 'totalizadorColunad',
      align: 'center',
      title: `${valorTotalD}`,
      children: [
        {
          title: 'D',
          children: [
            {
              title: 'Requisitado',
              dataIndex: 'requisitado',
              align: 'center',
            },
          ],
        },
      ],
    },
    {
      dataIndex: 'totalizadorColunaEbcd',
      align: 'center',
      title: `${valorTotalE}`,
      children: [
        {
          title: 'e = b - c + d',
          children: [
            {
              title: 'Compromissado',
              dataIndex: 'compromissado',
              align: 'center',
            },
          ],
        },
      ],
    },
    {
      dataIndex: 'totalizadorColunaF',
      align: 'center',
      title: `${valorTotalF}`,
      children: [
        {
          title: 'F',
          children: [
            {
              title: 'A Contratar',
              dataIndex: 'aContratar',
              align: 'center',
            },
          ],
        },
      ],
    },
    {
      dataIndex: 'totalizadorColunaGbdff',
      align: 'center',
      title: `${valorTotalG}`,
      children: [
        {
          title: 'g = b + d + f',
          children: [
            {
              title: 'Forecast',
              dataIndex: 'forecast',
              align: 'center',
            },
          ],
        },
      ],
    },
    {
      dataIndex: 'totalizadorColunahag',
      align: 'center',
      title: `${valorTotalH}`,
      children: [
        {
          title: 'h = a - g',
          children: [
            {
              title: 'variação',
              dataIndex: 'saldoCapEx',
              align: 'center',
            },
            {
              title: '%',
              dataIndex: 'saldoCapExPercentual',
              align: 'center',
              sorter: (a, b) => compareText(a.saldoCapExPercentual, b.saldoCapExPercentual),
              render: (text, row, index) => {
                return <> {row.saldoCapExPercentual != null ? row.saldoCapExPercentual : 'N/A'} </>;
              },
            },
            {
              title: '',
              align: 'center',
              sorter: (a, b) => compareText(a.saldoCapExPercentualCor, b.saldoCapExPercentualCor),
              render: (text, row, index) => {
                return <Icon type="check-circle" theme="twoTone" twoToneColor={row.saldoCapExPercentualCor} />;
              },
            },
          ],
        },
      ],
    },
  ];

  if (mostrarColunaDetalhe) {
    colluns.push({
      title: `Detalhe`,
      align: 'center',
      render: (text, row, index) => {
        return (
          <>
            {row.id === idVrp ? (
              <></>
            ) : (
              <Button
                onClick={() => {
                  window.open(`/Cr/relatorios/relatorioCicloOrcamentarioProjeto/dadosgerais?projetoId=${row.id}`);
                }}
                icon="commons-search"
              />
            )}
          </>
        );
      },
    });
  }

  if (mostrarColunaDetalheFechamento === true) {
    colluns.push({
      title: `Detalhe`,
      align: 'center',
      render: (text, row, index) => {
        return (
          <>
            {row.id === idVrp ? (
              <></>
            ) : (
              <Button
                onClick={() => {
                  window.open(`/Cr/detalheProjetoFechamento/dadosGerais?fechamentoId=${fechamentoId}&projetoId=${row.id}`);
                }}
                icon="commons-search"
              />
            )}
          </>
        );
      },
    });
  }

  const calcularCabecalhoDaTabela = (extra: TableCurrentDataSource<CicloOrcamentarioRelatorioResult>) => {
    let totalA = 0;
    let totalB = 0;
    let totalC = 0;
    let totalD = 0;
    let totalE = 0;
    let totalF = 0;
    let totalG = 0;
    let totalH = 0;

    extra.currentDataSource.map(item => {
      totalA += item.capExDecimal;
      totalB += item.contratadoDecimal;
      totalC += item.executadoDecimal;
      totalD += item.requisitadoDecimal;
      totalE += item.compromissadoDecimal;
      totalF += item.aContratarDecimal;
      totalG += item.forecastDecimal;
      totalH += item.saldoCapExDecimal;
    });

    setValorTotalA(formatCurrencyBr(totalA));
    setValorTotalB(formatCurrencyBr(totalB));
    setValorTotalC(formatCurrencyBr(totalC));
    setValorTotalD(formatCurrencyBr(totalD));
    setValorTotalE(formatCurrencyBr(totalE));
    setValorTotalF(formatCurrencyBr(totalF));
    setValorTotalG(formatCurrencyBr(totalG));
    setValorTotalH(formatCurrencyBr(totalH));
  };

  return (
    <Table
      rowKey="id"
      id="tableResultCicloOrcamentario"
      columns={colluns}
      dataSource={cicloOrcamentarioRelatorioResult.result}
      pagination={
        {
          pageSize: quantidadeItemPaginacao,
          onChange: () => {
            document.getElementById('tableResultCicloOrcamentario').scrollIntoView();
          },
        } as PaginationConfig
      }
      onChange={(pagination, filters, sorter, extra) => {
        calcularCabecalhoDaTabela(extra);
      }}
    />
  );
};

export default RelatorioCicloOrcamentarioTabela;
